import { Controller } from '@hotwired/stimulus'

// Approximate Devise's email format (Devise.email_regexp = /\A[^@\s]+@[^@\s]+\z/).
// Client-side guard only; the server re-validates.
const EMAIL_REGEX = /^[^@\s]+@[^@\s]+$/

export default class extends Controller {
  static targets = ['email', 'submit']

  connect() {
    this.validate()
  }

  validate() {
    this.submitTarget.disabled = !EMAIL_REGEX.test(this.emailTarget.value.trim())
  }
}
